export interface Industry {
  id?: number | null
  industry: string
}

export enum IndustryOption {
  Any = 'any',
  AdTech = 'adtech',
  AerospaceDefense = 'aerospace & defense',
  AgricultureForestry = 'agriculture & forestry',
  ArtificialIntelligence = 'artificial intelligence',
  Blockchain = 'blockchain',
  BusinessSupportServices = 'business support services',
  BusinessTechnology = 'business technology',
  Cannabis = 'cannabis',
  CloudComputing = 'cloud computing',
  ConsumerGoods = 'consumer goods',
  ConsumerInformationServices = 'consumer information services',
  Cryptocurrency = 'cryptocurrency',
  Cybersecurity = 'cybersecurity',
  Diagnostics = 'diagnostics',
  DroneTechnology = 'drone technology',
  ECommerce = 'e-commerce',
  Education = 'education',
  EnterpriseSoftware = 'enterprise software',
  EnterpriseTechnology = 'enterprise technology',
  EntertainmentTechnology = 'entertainment technology',
  FinancialServices = 'financial services',
  FinancialTechnology = 'financial technology',
  FoodBeverage = 'food & beverage',
  GovernmentServices = 'government services',
  HealthcareServices = 'healthcare services',
  HealthcareTechnology = 'healthcare technology',
  Logistics = 'logistics',
  MachineryIndustrialGoods = 'machinery & industrial goods',
  Manufacturing = 'manufacturing',
  MarketingSalesTechnology = 'marketing & sales technology',
  MediaContent = 'media & content',
  MedicalDevices = 'medical devices',
  MobileTechnology = 'mobile technology',
  NonRenewableEnergy = 'non-renewable energy',
  Pharmaceuticals = 'pharmaceuticals',
  PrivateEquityFunds = 'private equity funds',
  PropTech = 'proptech',
  Quantum = 'quantum',
  RealEstate = 'real estate',
  RenewableEnergy = 'renewable energy',
  Space = 'space',
  TechnologyServices = 'technology services',
  Therapeutics = 'therapeutics',
  Transportation = 'transportation',
  TravelLeisure = 'travel & leisure',
  VentureFunds = 'venture funds'
}

const industryOpts = Object.entries(IndustryOption).map(([, opt]) => opt);
const IndustryOptionArray = industryOpts.sort((a, b) => {
  if (a === IndustryOption.Any) return -1;
  if (b === IndustryOption.Any) return 1;
  return a <= b ? -1 : 1;
});
export const EntIndustryOptionArray = IndustryOptionArray.filter((o: any) => o !== IndustryOption.Any);
export const InvestorIndustryOptionArray = IndustryOptionArray;

export const InvestorIndustryList: Industry[] = InvestorIndustryOptionArray.map((i) => ({ industry: i }));
export const EntIndustryList: Industry[] = EntIndustryOptionArray.map((i) => ({ industry: i }));
